import React from "react";

const Unlink = ({ customComponent, onClick, isActive, isDisabled }) => {
	const doUnlink = () => {
		if (onClick) onClick();
	};

	return (
		<>
			<button
				className={`editor-menu-item${isActive ? " is-active" : ""}`}
				onClick={doUnlink}
				title="Remove hyper link"
				type="button"
				disabled={isDisabled}>
				{customComponent ? customComponent : <i className="fas fa-unlink" />}
			</button>
		</>
	);
};

export default Unlink;
